import { create } from 'zustand';

const useFeedClient= create((set) => ({
  feedClient: null,
  setFeedClient: (newClient) => set({ feedClient: newClient }),
}));

export default useFeedClient;

